import QueryString from "qs";
import dynamic from "next/dynamic";
import Layout from "../../layout/Layout";

const Header = dynamic(() => import("../../layout/common/header"));
const Troofooter = dynamic(() => import("../../layout/common/troofooter"));
const ServicePage = dynamic(() => import("../../components/pages/ServicePage"));
const GhostPage = dynamic(() => import("../../components/pages/GhostPage"));

let baseUrl = process.env.NEXT_PUBLIC_REACT_APP_API_BASE_URL;

export const getServerSideProps = async (ctx) => {
	if (process.env.NEXT_PUBLIC_CACHE_PAGES) {
		ctx.res.setHeader(
			"Cache-Control",
			"public, s-maxage=1800, stale-while-revalidate=59",
		);
	}
	const slug = ctx.params.slug;

	let apiRes = null;
	let apiResData = null;
	let isNew = false;
	const query = QueryString.stringify(
		{
			filters: {
				slug: {
					$eq: slug,
				},
			},
			populate: "deep,7",
		},
		{
			encodeValuesOnly: false,
		},
	);
	apiRes = await fetch(`${baseUrl}services?${decodeURIComponent(query)}`);
	apiResData = await apiRes.json();

	isNew = apiResData.data[0].attributes.design === "new";

	return {
		props: {
			apiResData,
			slug,
			isNew,
		},
	};
};

// let NewComponent = null;
const Service = ({ apiResData, slug }) => {
	return (
		<div id="root">
			{/* <div className="middle-sction middle-pad"> */}
			{apiResData.data[0].attributes.template === "ghost-page" ? (
				<GhostPage slug={slug} data={apiResData} />
			) : (
				<ServicePage slug={slug} data={apiResData} />
			)}
			{/* </div> */}
		</div>
	);
};

Service.getLayout = function getLayout(page, props) {
	return (
		<Layout isNew={props.isNew} pageSlug={props.slug}>
			{page}
		</Layout>
	);
};

export default Service;
